<div class="flex items-center gap-x-[10px] mt-3 lg:mt-0">
  <ui-kit-badge
    class="!flex cursor-pointer"
    [tp]="tokensMenu"
    tpPlacement="bottom"
    tpVariation="menu"
    [class.pointer-events-none]="isTrial() || !isOrganizationOwner()"
  >
    <div class="flex items-center gap-x-1 text-typography-default whitespace-nowrap">
      <img
        ngSrc="/assets/images/icons/coin.svg"
        alt="Coin"
        width="16"
        height="16"
        aria-hidden="true"
        priority
        class="hidden lg:block"
      />
      {{ 'navbar.badge.searches-left' | transloco: { searchesLeft: tokens() } }}
    </div>
  </ui-kit-badge>

  @if (subscriptionPlan()) {
    <button (click)="openBuyPlanDialog()" [class.pointer-events-none]="!isOrganizationOwner()">
      @if (!isTrial()) {
        <ui-kit-badge [type]="'default'" class="!flex">
          <div class="flex items-center gap-x-1">
            {{ 'membership.plan.' + (subscriptionPlan() | lowercase) | transloco }}
          </div>
        </ui-kit-badge>
      } @else {
        <ui-kit-badge [type]="'action'" class="!flex">
          <div class="flex items-center gap-x-1">
            {{ 'membership.plan.buy.trial' | transloco }}
          </div>
        </ui-kit-badge>
      }
    </button>
  }
</div>

<ng-template #tokensMenu let-hide>
  <div class="min-w-64">
    <div class="flex w-full items-center gap-x-[6px]">
      <span class="text-xs text-typography-muted">
        <strong class="text-sm text-typography-primary">{{ tokens() }}</strong>
        /{{ totalTokens() }}
      </span>
      <ui-kit-progress-bar [type]="'primary'" [percentage]="tokensPercentage()" class="flex-1" />
    </div>
    <button ui-kit-button [variant]="'secondary'" class="w-full mt-[6px]" (click)="openBuyTokensDialog(); hide()">
      {{ 'membership.tokens.buy' | transloco }}
    </button>
  </div>
</ng-template>
